module.exports = __webpack_public_path__ + "static/media/regionsAndLicenses.7d5ec1e9.svg";